<template>
  <div class="p-dept__mv" :style="setStyleMv()">
    <div class="p-dept__mvBg" :style="setStyleImg()">
      <video
        :src="video"
        muted
        autoplay
        playsinline
        loop
      ></video>
    </div>
    <div class="p-dept__mvWrap">
      <div class="p-dept__mvWrap__logo">
        <img v-if="imgLogo" :src="imgLogo" alt="" />
        <!--
        <p v-html="copy"></p>
        -->
      </div>
      <div class="p-dept__mvWrap__scroll" @click="gotoHead"><span>SCROLL</span></div>
    </div>
  </div>
</template>

<script>
  import { assets_path, breakpoint } from '@/_modules/utils/variables'
  import store from '@/_modules/stores';
  import {gsap, TweenMax, Cubic, ScrollToPlugin} from 'gsap/all';
  gsap.registerPlugin(ScrollToPlugin);

  export default {
    props: ['type', 'copy', 'video'],
    data() {
      return {
        assets_path: assets_path,
        ispc: false,
        styleMv: '',
        styleImg: '',
        imgLogo: ''
      }
    },
    store,
    computed: {
      setStyleMv: function() {
        return function() {
          return this.styleMv;
        }
      },
      setStyleImg: function() {
        return function() {
          return this.styleImg;
        }
      }
    },
    created() {
      if (this.type === 'tech') {
        this.imgLogo = `${assets_path}img/common/logo-pics-${this.type}-w.svg`;
      } else if (this.type === 'c4n') {
        this.imgLogo = `${assets_path}img/c4n/logo-white.png`;
      } else if (this.type === 'st') {
        this.imgLogo = `${assets_path}img/common/logo-pics-${this.type}-w@2x.png`;
      } else {
        this.imgLogo = `${assets_path}img/common/logo-pics-${this.type}-w.png`;
      }
    },
    mounted() {
      this.resize();
      window.addEventListener('resize', this.resize);
    },
    methods: {
      resize() {
        const imgW = 16;
        const imgH = 9;
        let winW = this.$_getBodyWidth();
        let winH = window.innerHeight;

        if (window.innerWidth > breakpoint) {
          this.ispc = true;
        } else {
          this.ispc = false;
        }

        if (this.ispc || (!this.ispc && this.preWidth !== window.innerWidth)) {
          // ブラウザサイズにフィット
          const bgW = winW;
          const bgH = winH;
          const scale = Math.max(bgW / imgW, bgH / imgH);
          const frameW = imgW * scale;
          const frameH = imgH * scale;
          const frameX = (winW - frameW) / 2;
          const frameY = (winH - frameH) / 2;

          this.styleMv = `height:${winH}px;width:${winW}px`;
          this.styleImg = `height:${frameH}px; width:${frameW}px; left:${frameX}px; top:${frameY}px;`;
        }

        this.preWidth = window.innerWidth;
      },
      gotoHead() {
        const posY = this.$el.getBoundingClientRect().height;

        TweenMax.to(window, 0.4, {
          scrollTo:{
            y: posY,
            autoKill: false
          },
          ease: Cubic.easeOut}
        );
      }
    }
  }
</script>
